import unfetch from 'unfetch';
export function getFetch() {
    return typeof fetch === 'function' ? fetch : unfetch;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/platform/getFetch/browser.js
// module id = 3945
// module chunks = 25